import authService from './authService/authService';
import loginDialog from './loginDialog/loginDialog';

export default angular
  .module('services.security', [
    authService,
    loginDialog,
  ])
  .name;
